import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
const Wrapper = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  padding: spacing(2),
  display: 'flex',
  alignItems: 'center',
  position: 'sticky',
  zIndex: 1,
  top: 0,
  background: palette.background.primary,
  borderBottom: `1px solid ${palette.line}`
}));
export interface TocHeaderProps {
  onClose: () => void;
}
const TocHeader = t0 => {
  const $ = _c(6);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexGrow: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography sx={t1} variant="h6" component="h2">{translate("course_toc.title")}</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = translate("global.action.close_button");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CloseIcon />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClose) {
    t5 = <Wrapper>{t2}<IconButton onClick={onClose} aria-label={t3} size="large">{t4}</IconButton></Wrapper>;
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default TocHeader;